import React from 'react'
import styled from 'styled-components'

interface Props extends React.HTMLAttributes<HTMLTableCellElement> {
    children: React.ReactNode | React.ReactNode[];
    background?: string;
    isSticky?: boolean;
    index?: number;
}

const TableBodyCell = ({
    children, background, isSticky, index, ...props
}: Props) => {
  return (
    <TableBodyCellStyle
    $background={background}
    $isSticky={isSticky}
    
    $indexExternal={index}
        {...props}
    >
        <Wrapper>
            {children}
        </Wrapper>
    </TableBodyCellStyle>
  )
}
const TableBodyCellStyle = styled.td<{$background?: string, $isSticky?: boolean, $indexExternal?: number}>`
    position: relative;
    max-width: max-content;
    direction: ltr;
    text-align: right;
    overflow: hidden;
    padding: 0.2em;
    box-shadow: 0 0 5px rgba(0,0,0,0.2);
    border-radius: 4px;
    background: ${props => props.$background ? props.$background : '#fff'};
    color: rgba(0,0,0,0.7);
    z-index: 0;
    // Добавляем sticky позиционирование для первого столбца
    ${props => props.$isSticky && `
        position: sticky;
        right: 0;
        z-index: 1;
    `}
    ${props => props.$indexExternal && props.$indexExternal > 0 && `
        right: ${props.$indexExternal}99px;
    `}

    
    svg {
        margin-left: 0.5em;
        color: #81B4AF;
    }
    
`
const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    direction: rtl;

`
export default TableBodyCell